import moment from 'moment';

import {
  getIssuesByIterationByTeam,
  extractAlertsFromBranch
} from 'common/services/graphql.service';
import { SEARCH_DATE_FORMAT } from 'common/constants/constants';
import { pluralize } from 'common/utils/utils';
import { ALERT_TYPES } from 'common/constants/alertTypes';
import { ALERTS_LIMIT_SHOW } from './index';
import { ISSUES_PERIOD } from '../../teamDashboardCurrentIterationV2.service';

export const fetchIssuesData = async (
  currentIteration,
  currentTeam,
  sensor_id,
  isTeamPMConfigurationEnabled
) => {
  return getIssuesByIterationByTeam({
    iteration: currentIteration,
    team: currentTeam,
    sensor_id,
    timelineStartDate: moment()
      .subtract(ISSUES_PERIOD, 'day')
      .format(SEARCH_DATE_FORMAT),
    projectId: currentTeam.project_id,
    isTeamPMConfigurationEnabled
  });
};

export const getStuckIssuesDataForUi = (issues = [], contributors = []) => {
  const dataForUi = mapDataToUi(issues, contributors);

  return dataForUi.filter(
    issue => issue.alerts.length && issue.jiraIssueState === 'in-progress'
  );
};

export const getIssueAlertText = alert => {
  const alertType = ALERT_TYPES[alert.type]; // TODO: use extract alert from withUnmatched
  return `${alertType.alert_title} (${alertType.time_format(alert)})`;
};

export const mapDataToUi = (issues = [], contributors) => {
  return issues.map(issue => {
    const {
      id,
      branches,
      title,
      provider_state,
      issue_state,
      subtasks = [],
      provider_type_icon_url,
      html_url,
      provider_type,
      provider_key
    } = issue;

    const branchesWithSubTaskBranches = (branches || []).concat(
      (subtasks || []).flatMap(({ branches }) => branches)
    );

    const alerts = branchesWithSubTaskBranches.flatMap(branch => {
      return extractAlertsFromBranch(branch, contributors);
    });

    return {
      jiraIssueState: issue_state,
      iconUrl: provider_type_icon_url,
      jiraLink: html_url,
      issueId: id,
      issueName: title,
      issueType: provider_type,
      issueState: provider_state,
      issueKey: provider_key,
      alerts
    };
  });
};

export const generateTitle = (numOfIssues = 0) => {
  const msgOfNum =
    numOfIssues > 3
      ? `${numOfIssues} of ${ALERTS_LIMIT_SHOW}`
      : `${numOfIssues}`;
  return `${msgOfNum} ${pluralize(
    numOfIssues,
    'Stuck issue',
    undefined,
    false
  )}`;
};
